import React from 'react'
import { useParams } from 'react-router-dom'
import blogDetails from '../components/BlogsDetails';
import Header from '../components/header';
import Footer from '../components/footer';
import { Helmet } from 'react-helmet'

export default function Blog() {
  let { id } = useParams();

  let data = blogDetails.find(v => v.id === id);


  return (
    <div>
      <Header />
      <Helmet>
        <html lang="en" />
        <title>{`${data.post} | Tooliso Blog`}</title>
        <meta name="description" content={data.intro1} />

        <meta property="og:title" content={`${data.post} | Tooliso Blog`} />
        <meta property="og:description" content={data.intro1} />
        <meta property="og:type" content="article" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${data.post} | Tooliso Blog`} />
        <meta name="twitter:description" content={data.intro1} />
      </Helmet>
      <div className="qr-wrapper">
        <div className="qr-container">
          <h1 className="qr-title">{data.post}</h1>
          <p className="qr-intro">{data.intro1}</p>
          <p className="qr-brand"><strong>{data.brand}</strong> {data.intro2}</p>

          <h2 className="qr-section-heading">{data.section1Heading}</h2>
          <p className="qr-paragraph">{data.innersection1}</p>

          <h2 className="qr-section-heading">{data.section2Heading}</h2>
          <ul className="qr-list">
            {data.section2.map((item, index) => (
              <li key={index}><strong>{item.heading}:</strong> {item.comment}</li>
            ))}
          </ul>

          <h2 className="qr-section-heading">Benefits</h2>
          <ul className="qr-list">
            {data.section3.map((item, index) => (
              <li key={index}><strong>{item.heading}:</strong> {item.comment}</li>
            ))}
          </ul>

          <h2 className="qr-section-heading">{data.heading3}</h2>
          <p className="qr-paragraph">{data.comment3}</p>
          <ol className="qr-steps">
            {data.section4.map((item, index) => (
              <li key={index}>
                <strong>{item.heading}</strong> – {item.comment}
              </li>
            ))}
          </ol>
        </div>
      </div>
      <Footer />
    </div>
  )
}
